import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'calsoft-return-policy',
  templateUrl: './return-policy.component.html',
  styleUrls: ['./return-policy.component.scss']
})
export class ReturnPolicyComponent implements OnInit {

  public PageTitle = "returnPolicy";
  constructor() { }

  ngOnInit(): void {
  }

}
